import React, { useState } from 'react';
import { AddColorContainer, ErrorMessage } from './styled';
import { Input } from '@unfold/input';
import { Button } from '@unfold/button';
import { GridItem, Grid } from '@unfold/grid';
import { ChromePicker, ColorResult } from 'react-color';
import { pickerStyles, ERROR_MESSAGE } from './constants';
import { isHex } from '@unfold/utils';

interface IAddColorProps {
  onColorAdded: (color: string) => void;
  onCancelClick: () => void;
}

export const AddColor: React.FC<IAddColorProps> = ({
  onColorAdded,
  onCancelClick,
}) => {
  const [selectedColor, setSelectedColor] = useState<string>('');
  const [hasError, setError] = useState<boolean>(false);

  const handleColorChange = (e: React.ChangeEvent<HTMLInputElement>): void =>
    setSelectedColor(e.target.value);

  const handleColorAdd = (color: ColorResult): void =>
    setSelectedColor(color.hex);

  const handleColorAdded = (): void => {
    if (selectedColor && isHex(selectedColor)) {
      if (selectedColor[0] !== '#') {
        onColorAdded(`#${selectedColor}`);
      } else {
        onColorAdded(selectedColor);
      }
      setError(false);
    } else {
      setError(true);
    }
  };

  return (
    <AddColorContainer>
      <Input
        placeholder="#FFFFFF"
        onChange={handleColorChange}
        value={selectedColor}
      />
      {hasError && <ErrorMessage>{ERROR_MESSAGE}</ErrorMessage>}
      <ChromePicker
        color={selectedColor}
        onChange={handleColorAdd}
        styles={pickerStyles}
      />
      <Grid horizontalPadding={20}>
        <GridItem isStretch>
          <Button appearance="primary" onClick={handleColorAdded} width="100%">
            ADD
          </Button>
        </GridItem>
        <GridItem isStretch>
          <Button appearance="bordered" onClick={onCancelClick} width="100%">
            CANCEL
          </Button>
        </GridItem>
      </Grid>
    </AddColorContainer>
  );
};
